import React from 'react';

function Notification(props) {
  let extraClasses;
  if (props.danger) extraClasses += ' is-danger';
  if (props.succes) extraClasses += ' is-success';
  if (!props.children) {
    return null;
  }
  else {
    return (
      <div className={"notification " + extraClasses}>
        {props.children}
      </div>
    )
  }
}

export default Notification;
